import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZippyClassDirective } from './zippy-class.directive';
import { ZippyCloseDirective } from './zippy-close.directive';
import { ZippyGroupClassDirective } from './zippy-group-class.directive';
import { ZippyHideUpComponent } from './zippy-hide-up.component';
import { ZippyOpenDirective } from './zippy-open.directive';
import { ZippyToggleDirective } from './zippy-toggle.directive';
import { ZippyDirective } from './zippy.directive';
import { ZippyIfDirective } from './zippy-if.directive';

const ASSETS = [
    ZippyDirective,
    ZippyClassDirective,
    ZippyCloseDirective,
    ZippyGroupClassDirective,
    ZippyOpenDirective,
    ZippyToggleDirective,
    ZippyHideUpComponent,
    ZippyIfDirective
];

/**
 * @deprecated Use ToggleState or direct switches
 */
@NgModule({
    declarations: ASSETS,
    exports: ASSETS,
    imports: [CommonModule]
})
export class ZippyModule {}
